import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  detailBuildEmployer,
  updateBuildEmployer,
} from "../../actions/employerAction";
import axios from "axios";
import CreatableSelect from "react-select/creatable";
import { skillsdata } from "../../data/skillsdata";
import AdminMenu from "../../components/AdminMenu";
import RightDash from "../../components/RightDash";
import Signout from "../../components/Signout";
import Message from "../../components/Message";
import Login from "../Login";
import "../../styles/dashboard.css";

import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const AdminJobEdit = ({ match, history, resizeMenu, setResizeMenu }) => {
  const id = match.params.id;

  let checkUrl = history.location.pathname.indexOf("admin");

  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [file, setFile] = useState([]);
  const [budget, setBudget] = useState(0);
  const [skill, setSkill] = useState("");
  const [fileList, setFileList] = useState([]);
  const [cloudList, setCloudList] = useState([]);

  const dispatch = useDispatch();

  const detailBuild = useSelector((state) => state.detailBuild);

  const { loading, job, error } = detailBuild;

  const updateBuild = useSelector((state) => state.updateBuild);

  const { updateloading, job: updatejob, error: updateerror } = updateBuild;

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;
  useEffect(() => {
    dispatch(detailBuildEmployer(id));
  }, [detailBuildEmployer]);

  useEffect(() => {
    if (job !== undefined && Object.keys(job).length) {
      setTitle(job.title);
      setDetails(job.details);
      setSkill(job.skill);
      setBudget(job.budget);
      setCloudList(job.file);
      // setFileList(job.file)
      // setFile(cloudList);
    }
  }, [job]);

  // if (!userInfo) {
  //   return <Login />;
  // }

  // if (userInfo && userInfo.role === "developer") {
  //   history.push("/developer/dashboard");
  // }

  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(fileList);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    const image = new FormData();
    image.append("upload_preset", "fz0bvgt7");
    image.append("file", file);
    const config = {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    };
    axios
      .post("https://api.cloudinary.com/v1_1/teqporte/upload", image, config)
      .then((res) => {
        const secureUrl = res.data.secure_url;
        const newList = [...cloudList, secureUrl];
        // const fileList = [...file, secureUrl];
        setCloudList(newList);
        // setFile(cloudList);
      });
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleSelect = (newValue, actionMeta) => {
    let skillArr = newValue.map((item) => {
      return item.value;
    });
    setSkill(skillArr);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!skill.length) {
      return message.error("Skill field is required");
    }
    dispatch(
      updateBuildEmployer(title, details, skill, cloudList, budget, history, id)
    );
  };

  return (
    <div className="dashboard">
      <AdminMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <div className="bio text-right">
              <button>
                <span>Hello Admin, Welcome!</span>
                <span className="px-50 py-25 rounded-circle ml-25 font-weight-bold font-sm">
                  A
                </span>
              </button>
            </div>
            <div className="main p-3">
              <div className="">
                <h4 className="font-medium mb-2">Edit</h4>
                <div className="form-wrapper">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-1">
                      <label className="mb-25 d-inline-block">
                        Give your job a title
                      </label>
                      <div className="dashinput">
                        <input
                          type="text"
                          name="name"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          placeholder="Develop a web app for ecommerce"
                        />
                      </div>
                    </div>
                    <div className="">
                      <label className="mb-25 d-inline-block">
                        Describe the job in details
                      </label>
                      <div className="dashinput">
                        <p className="mb-25 text-black-fade">
                          Include requirements and time frame for delivery
                        </p>
                        <textarea
                          rows="10"
                          value={details}
                          onChange={(e) =>
                            setDetails(e.target.value)
                          }></textarea>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="my-25 d-inline-block">
                        include file(if available)
                      </label>
                      <div className="dashinput">
                        <Dragger
                          fileList={fileList}
                          onChange={handleChange}
                          customRequest={dummyRequest}>
                          <p>
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                        </Dragger>
                        <p className="mb-25 text-black-fade">
                          {cloudList && cloudList.slice(0, 1).join(", ")}
                        </p>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25 d-inline-block">
                        What skills are required
                      </label>
                      <div className="dashinput">
                        <p className="mb-25 text-black-fade">
                          Enter up to 3 skills that best describe your project.
                          Developers will use these skills to find projects they
                          are most interested and experienced in.
                        </p>
                        <CreatableSelect
                          isMulti
                          name="skill"
                          options={skillsdata}
                          onChange={handleSelect}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          required
                        />
                        <p className="mb-25 text-black-fade">
                          {skill && skill.join(", ")}
                        </p>
                      </div>
                    </div>
                    <div className="mb-1">
                      <label className="mb-25 d-inline-block">
                        Budget Offer(in USD)
                      </label>
                      <div className="dashinput">
                        <input
                          type="number"
                          name="salary"
                          placeholder="10000"
                          value={budget}
                          onChange={(e) => setBudget(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="my-2">
                      <button
                        className="d-flex justify-content-center button"
                        type="submit">
                        {updateloading ? (
                          <div className="spinner"></div>
                        ) : (
                          "SUBMIT"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default AdminJobEdit;
